import { useRef, type RefObject } from 'react';

import { enGB } from 'date-fns/locale';
import { DatePicker } from 'react-nice-dates';

import 'react-nice-dates/build/style.css';
import { ConfigBaseItem } from 'components/shared/ConfigBaseItem';
import { CalendarIcon } from 'components/shared/Icons/InfoIcons';
import { ConfigInput } from 'components/shared/Input/ConfigInput.style';
import { getValidDateValue } from 'helpers/helpers';

import { DateWrapper } from './DateInput.style';
import { useFloatingDatePopover } from './useFloatingDatePopover';

type Props = {
  item: any;
  isDisabled?: boolean;
  handleChange: (date: Date | null) => void;
  children?: any;
};

export function DateInput({ item, isDisabled, handleChange, children }: Props) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  return (
    <DateWrapper ref={wrapperRef} className='dateWrapper'>
      <DatePicker
        locale={enGB}
        format='dd/MM/yyyy'
        date={getValidDateValue(item.DISPLAYVALUE)}
        onDateChange={handleChange}
      >
        {({ inputProps, focused }) => (
          <>
            <FloatingPopover open={focused} wrapperRef={wrapperRef} />
            <ConfigBaseItem
              item={item}
              render={children}
              leftIcon={<CalendarIcon />}
              className={'inputDateContainer'}
            >
              {({ baseStatus }) => (
                <ConfigInput
                  data-cy={`date-${item.FIELDID}`}
                  data-testid='input'
                  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
                  // @ts-ignore
                  modifiers={baseStatus.status}
                  className={'input' + (focused ? ' -focused' : ' ')}
                  {...inputProps}
                  disabled={isDisabled}
                />
              )}
            </ConfigBaseItem>
          </>
        )}
      </DatePicker>
    </DateWrapper>
  );
}

function FloatingPopover({
  open,
  wrapperRef,
}: {
  open: boolean;
  wrapperRef: RefObject<HTMLDivElement | null>;
}) {
  useFloatingDatePopover(wrapperRef, open);
  return null;
}
